export default function toPriceValue(value){
    let val = value.toString().replace(".", ",");

    if(val.indexOf(",") > -1){
        const valSeparated = val.split(",");
        return valSeparated[1].length < 2? val + "0" : val;
    }

    return val + ",00";
}